/* eslint-disable jira/filename-case */
import { performanceKeyPrefix } from './constants.tsx';

export const getPrefixedMarkName = (name: string): string => `${performanceKeyPrefix}${name}`;
